module.exports = __webpack_public_path__ + "static/media/SendIcon.6e55520b.svg";